// lib/utils/weatherUtils.ts
export function getTemperatureLabel(temp: number): string {
    if (temp <= -30) return 'Экстремальный мороз 🥶';
    if (temp <= -20) return 'Очень холодно ❄️';
    if (temp <= -10) return 'Морозно';
    if (temp <= 0) return 'Прохладно';
    if (temp <= 10) return 'Свежо';
    if (temp <= 20) return 'Умеренно';
    if (temp <= 30) return 'Тепло';
    return 'Жарко ☀️';
  }
  

 
// ✨ НОВАЯ ФУНКЦИЯ для получения стилей карточки по температуре
export const getCardAppearanceByTemp = (temp: number) => {
    if (temp >= 28) {
      return {
        gradient: 'from-red-500/80 to-orange-500/80',
        shadow: 'shadow-orange-400/30',
      };
    }
    if (temp >= 20) {
      return {
        gradient: 'from-yellow-500/70 to-orange-400/70',
        shadow: 'shadow-yellow-400/30',
      };
    }
    if (temp >= 10) {
      return {
        gradient: 'from-sky-500/70 to-blue-600/70',
        shadow: 'shadow-sky-400/30',
      };
    }
    if (temp >= 0) {
      return {
        gradient: 'from-blue-600/70 to-indigo-700/70',
        shadow: 'shadow-blue-400/30',
      };
    }
    return {
      gradient: 'from-indigo-700/80 to-purple-800/80',
      shadow: 'shadow-indigo-400/30',
    };
  };